import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { Toll } from "@mui/icons-material";

const PeajeChip = ({ nombre }) => (
  <Chip
    icon={<Toll sx={{ fontSize: 16 }} />}
    label={nombre}
    size="small"
    sx={{
      bgcolor: "#f1f5f9",
      color: "#40576d",
      fontWeight: 600,
      fontSize: "0.72rem",
      border: "1px solid #d8e2eb",
      "& .MuiChip-icon": { color: "#647b90" },
      m: 0.25,
    }}
  />
);

PeajeChip.propTypes = { nombre: PropTypes.string.isRequired };

export default PeajeChip;
